/*
Used in collection and search
*/
import { throttle } from "lodash";

/** @param {HTMLElement} baseElement */
export function init(baseElement) {
  sortBy(baseElement);
}

export function sortBy(baseElement) {
  const button = baseElement.querySelector("button");
  if (!(button instanceof HTMLButtonElement)) return;

  const openIcon = button.querySelector("[data-icon=down]");
  if (!(openIcon instanceof HTMLElement)) return;

  const closeIcon = button.querySelector("[data-icon=up]");
  if (!(closeIcon instanceof HTMLElement)) return;

  const list = baseElement.querySelector("ul");
  if (!(list instanceof HTMLUListElement)) return;

  let closed = true;

  function handleClick() {
    if (closed) {
      list.classList.remove("sort-by-ul--closed");
      button.classList.add("sort-by-button--open");
      openIcon.classList.add("hidden");
      closeIcon.classList.remove("hidden");
    } else {
      button.classList.remove("sort-by-button--open");
      list.classList.add("sort-by-ul--closed");
      openIcon.classList.remove("hidden");
      closeIcon.classList.add("hidden");
    }
    closed = !closed;
  }

  button.onclick = handleClick;

  // To prevent layout shift get the height of the container and pass it to the shopify section
  const sortByContainer = baseElement.querySelector("#sort-by-container");

  if (!(sortByContainer instanceof HTMLElement)) return;

  const sortByContainerStyle = getComputedStyle(sortByContainer);
  let sortByContainerHeight =
    parseInt(sortByContainerStyle.marginTop) +
    parseInt(sortByContainerStyle.marginBottom) +
    parseInt(sortByContainerStyle.height);
  baseElement.style.height = `${sortByContainerHeight}px`;

  const mainElement = document.querySelector("main");

  let prevScroll = window.pageYOffset;

  // TODO refactor
  function handleScroll() {
    let currentScroll = window.pageYOffset;
    // Fix for when scroll too fast to the top
    if (currentScroll == 0) {
      sortByContainer.classList.remove("fixed");
    }
    // When scroll below the main
    if (currentScroll < mainElement.offsetHeight && currentScroll !== 0) {
      // sort-by is visible
      sortByContainer.classList.add("fixed", "left-0", "right-0");
    } else {
      // should hide sort-by
      sortByContainer.classList.remove("fixed");
    }

    // When scrolled past sort-by AND not farther than main block height
    if (
      prevScroll >= baseElement.offsetTop &&
      currentScroll < mainElement.offsetHeight
    ) {
      // If scroll down
      if (prevScroll < currentScroll) {
        // @ts-ignore
        sortByContainer.style.transition = "none";
        // @ts-ignore
        sortByContainer.style.top = "0";
        baseElement.style.zIndex = "8";
        sortByContainer.classList.add("fixed", "left-0", "right-0");
      } else {
        // If scroll up
        // @ts-ignore
        sortByContainer.style.top = "var(--header-height)";
        // @ts-ignore
        sortByContainer.style.transition = "top 0.3s ease-in";
      }
    } else {
      sortByContainer.classList.remove("fixed", "left-0", "right-0");
    }
    prevScroll = currentScroll;
  }
  window.addEventListener("scroll", throttle(handleScroll, 100));
}
